import { accessNested, isObject, joinPaths } from 'utils/utils';
import Store from 'store/store';

let defaultRedirect = (geoFencedLocation, options) => {
	if (!geoFencedLocation) {
		return;
	}
	if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
		console.log('GEOFENCING GOING TO', geoFencedLocation);
		return;
	}

	// Try to prevent SOME infinite redirect loops (wouldn't catch a lot of things)
	let loopRisk = location.href === geoFencedLocation;
	if (!options?.allowSameHostRedirect) {
		let [, protocol, host] = /^((?:https?:)?\/\/)?([^/]+)/.exec(geoFencedLocation) || [];
		loopRisk = location.host === host;
	}
	if (!loopRisk) {
		location.href = geoFencedLocation;
	}
	return true;
};

let defaultGetRegionURL = (countryCode) => {
	return accessNested(Store.get(), ['dynamicData', 'regions', countryCode, 'url']);
};

export default async function geoFencing(getGeo, options) {
	if (!options) {
		options = {};
	}
	let redirect = typeof options.redirect === 'function' ? options.redirect : defaultRedirect;
	let redirectionActive = typeof location !== 'undefined' && !location.search.match(/[?&]redirect=(off|false|0|no)/);
	if (!redirectionActive || !window.__INITIAL_STATE__) {
		return;
	}
	let appData = window.__INITIAL_STATE__.appData || {};
	let queryString = window.location.search;
	let geoFence = appData.geofencing || {};
	let redirectObj = appData.redirection || {};
	let appRegion = accessNested(appData, 'meta.region.slug');

	let countryCode = (await getGeo()).countryCode;

	// allow for regions to be ignored per request
	const regionAllow = geoFence.allowRegions || '';
	const ignoreFor = regionAllow.split(',').map(region => region.trim().toLowerCase()).filter(e => e);
	const ignoreGeoFence = ignoreFor.indexOf(countryCode) !== -1;
	// check if site is in correct country (and ignore if it is)
	if (appRegion !== countryCode && geoFence.geofencing && !ignoreGeoFence) {
		let geoFencedLocation = accessNested(geoFence, ['overrides', countryCode]);
		if (!geoFencedLocation) {
			let getRegionURL = typeof options.getRegionURL === 'function' ? options.getRegionURL : defaultGetRegionURL;
			let regionUrl = await getRegionURL(countryCode);
			geoFencedLocation = regionUrl || geoFence.defaultLink;
		}
		if (geoFencedLocation) {
			let url;
			let noActivePage;
			if (isObject(geoFencedLocation)) {
				url = geoFencedLocation.url;
				noActivePage = geoFencedLocation.noActivePage;
			} else {
				url = geoFencedLocation;
				noActivePage = geoFence.noActivePage;
			}
			if (!noActivePage && !geoFence.stripRedirectionPath) {
				url = joinPaths(url, accessNested(Store.get(), 'activePage.path') || '/');
			}
			return redirect(url + queryString, geoFence);
		}
	} else {
		// standard redirect behaviour
		let optionsList = Object.keys(redirectObj).map(k => redirectObj[k]).concat(redirectObj).filter(e => e && e.url);
		let getActiveRedirect = Promise.resolve();
		optionsList.forEach(option => {
			getActiveRedirect = getActiveRedirect.then(activeRedirect => {
				if (activeRedirect) {
					return activeRedirect;
				}
				let checklist = [];

				if (option.country) {
					let list = option.country.split(',').map(e => e.trim());
					checklist.push(list.indexOf(countryCode) !== -1);
				}
				if (option.countryNot) {
					let list = option.countryNot.split(',').map(e => e.trim());
					checklist.push(list.indexOf(countryCode) === -1);
				}

				return Promise.all(checklist).then(listResults => listResults.every(e => e) ? option : activeRedirect).catch(() => activeRedirect);
			});
		});
		try {
			let redirect = await getActiveRedirect;
			if (redirect) {
				return redirect(redirect.url + queryString);
			}
		} catch (e) {
			console.log('Failed redirecting', e);
		}
	}
}
